interface CoveredVehicleLike {
  id?: number;
  organization_external_id?: string;
  vehicle?: { id?: number };
}

interface InvolvedVehicleLike {
  covered_vehicle_id?: string | number | null;
  vehicle?: { id?: number } | null;
}

// `covered_vehicle_id` carries two different things depending on where the involved vehicle
// came from, so all three are tried:
//
// - a backend-built draft references the covered vehicle by `organization_external_id`, the only
//   identifier stable across policy materializations (each FNOL request inserts its own Policy,
//   CoveredVehicle and Vehicle rows, so DB ids from one do not exist in another);
// - once a dialog or the dropdown has resolved a selection, the field holds the numeric
//   CoveredVehicle id from the policy the FE is showing;
// - otherwise fall back to matching the involved vehicle's own Vehicle id.
//
// The non-positive values are sentinels, not ids: 0 = Unlisted Vehicle, and -1 = Rental Vehicle
// on the legacy screen (Auto/AutoInvolved/VehicleDetails.jsx; NewFnolUI offers no Rental option).
export const findCoveredVehicle = (
  coveredVehicles: CoveredVehicleLike[] | undefined | null,
  involvedVehicle: InvolvedVehicleLike | undefined | null
): CoveredVehicleLike | undefined => {
  if (!coveredVehicles) {
    return undefined;
  }

  const coveredVehicleId = involvedVehicle?.covered_vehicle_id;

  if (typeof coveredVehicleId === 'string' && coveredVehicleId) {
    const byExternalId = coveredVehicles.find(
      (coveredVehicle) => coveredVehicle?.organization_external_id === coveredVehicleId
    );
    if (byExternalId) {
      return byExternalId;
    }
  }

  if (typeof coveredVehicleId === 'number' && coveredVehicleId > 0) {
    const byCoveredVehicleId = coveredVehicles.find((coveredVehicle) => coveredVehicle?.id === coveredVehicleId);
    if (byCoveredVehicleId) {
      return byCoveredVehicleId;
    }
  }

  const vehicleId = involvedVehicle?.vehicle?.id;
  return vehicleId ? coveredVehicles.find((coveredVehicle) => coveredVehicle?.vehicle?.id === vehicleId) : undefined;
};
